import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../../localization/language';
import * as verifyEmailActions from '../../../actions/verifyEmail';

class VerifyEmail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			errMsg: null,
			code: ''
		}
	}

	handleChangeCode(event) {
		this.setState({code: event.target.value});
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.verifyEmail(this.state.code);
	}
	
	getErrorDiv() {
		if (this.props.emailVerification.status) {
			return (
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{trans('error_code')}
				</div>
			);
		}
	}

	renderSaveEmailResult() {
		if (this.props.email.email) {
			return (
				<div className="content__result content__result--successful">
					<div className="content__result-icon content__result-icon--successful"></div>
					<div className="content__result-txt">
						{trans('change_email_success')}
					</div>
				</div>
			);
		}
	}

	render() {
		return (
			<div className="content">
				<div className="content-item content-item--ipage">
					<div className="content-item__title">
						{trans('verify_email_title')}
					</div>
					<div className="content-item__main">
						<div className="content-item--ipage__main">
							{this.renderSaveEmailResult()}
							<div className="content__sendinfo">
								{trans('check_email_hint1')} 
								<br/>{trans('check_email_hint2')} 
								<span className="content__sendinfo-b"> {trans('check_email_hint3')} </span> 
								{trans('check_email_hint4')} <span className="content__sendinfo-b">{trans('check_email_hint5')}</span> {trans('check_email_hint6')}.
							</div>
							<div className="content__form">
								<form method="post" action="" id="J-validated-form" onSubmit={this.handleSubmit.bind(this)}>
									<div className="content__email">
										<div className="content__email-icon"></div>
										<div className="content__email-addr">
											{this.props.userInfo.email}
										</div>

									</div>
									<div className="content__form-input">
										<input type="tel" maxLength="8" className="content__form-input-widget J-validated-field"
											placeholder={trans('verify_code_placeholder')} onChange={this.handleChangeCode.bind(this)}>
										</input>
									</div>
									<div className="content__form-errmsg" id="J-errdisplay-otp">
										{this.getErrorDiv()}
									</div>
									<div className="content__submit-wrap">
										<input type="submit" className="content__submit" value={trans('verify_btn')}></input>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
// add this button after the feature is implemented
// <a className="content__email-link" href="#">
// 	{trans('check_email_btn')}
// </a>


function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		emailVerification: state.emailVerification,
		email: state.email
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, verifyEmailActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmail);



// WEBPACK FOOTER //
// ./app/components/security/verify_email/VerifyEmail.js